export const SUPPORTED_LANG = "SUPPORTED_LANG";